import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-user-subscriptions',
    templateUrl: './user-subscriptions.component.html',
    styleUrls: ['./user-subscriptions.component.scss'],
})
export class UserSubscriptionsComponent implements OnInit {
    profile_picture: string;
    ngOnInit() {
        this.profile_picture = '/assets/images/no-image.png';
    }
}
